var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.82031 0.609375L11.682 2.34767L9.82031 4.08596M9.82031 9.88027L11.682 8.14198L9.82031 6.40369",
    stroke: "#F96800",
    strokeWidth: 0.883815,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.509766 2.34717H2.3715C3.19444 2.34717 3.98367 2.65241 4.56558 3.19573C5.14748 3.73905 5.4744 4.47595 5.4744 5.24433C5.4744 6.0127 5.80131 6.7496 6.38321 7.29292C6.96512 7.83625 7.75435 8.14148 8.57729 8.14148H11.6802M11.6802 2.34717H8.57729C7.90577 2.34633 7.25223 2.54973 6.71555 2.9266M4.23324 7.56205C3.69614 7.93816 3.04288 8.14148 2.3715 8.14148H0.509766",
    stroke: "#F96800",
    strokeWidth: 0.883815,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndMode);
export default __webpack_public_path__ + "static/media/AndMode.04f6648a085c25a27b174e95253ee649.svg";
export { ForwardRef as ReactComponent };